<template>
  <div class="cookie-consent-overlay">
    <div class="cookie-consent-container">
      <div class="cookie-consent-content">
        <h3 class="cookie-consent-title">Cookie 设置</h3>
        <p class="cookie-consent-text">
          我们使用 Cookie 以允许我们网站的正常工作、个性化设计内容和广告、提供社交媒体功能并分析流量。
        </p>
        <div class="cookie-consent-buttons">
          <button class="consent-btn accept-btn" @click="$emit('accept')">接受所有 Cookie</button>
          <button class="consent-btn reject-btn" @click="$emit('reject')">全部拒绝</button>
          <button class="consent-btn settings-btn" @click="$emit('open-settings')">Cookie 设置</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieConsentDialog',
  emits: ['accept', 'reject', 'open-settings']
}
</script>

<style scoped>
.cookie-consent-overlay {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.cookie-consent-container {
  background-color: var(--card-background);
  border-radius: var(--radius-lg);
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 900px;
  overflow: hidden;
  border: 1px solid var(--border-color);
  animation: slide-up 0.3s ease-out;
}

@keyframes slide-up {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.cookie-consent-content {
  padding: 24px;
}

.cookie-consent-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
  color: var(--text-primary);
}

.cookie-consent-text {
  font-size: 14px;
  line-height: 1.6;
  color: var(--text-secondary);
  margin-bottom: 20px;
}

.cookie-consent-buttons {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.consent-btn {
  padding: 10px 20px;
  border-radius: var(--radius-sm);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid transparent;
}

.accept-btn {
  background: linear-gradient(90deg, #4461F2 0%, #38BFFF 100%);
  color: white;
}

.accept-btn:hover {
  box-shadow: 0 8px 16px rgba(68, 97, 242, 0.25);
  transform: translateY(-2px);
}

.reject-btn {
  background-color: transparent;
  color: var(--text-primary);
  border: 1px solid var(--border-color);
}

.reject-btn:hover {
  border-color: var(--primary-color);
  color: var(--primary-color);
}

.settings-btn {
  background-color: transparent;
  color: var(--primary-color);
}

.settings-btn:hover {
  background-color: rgba(68, 97, 242, 0.1);
}

@media (max-width: 768px) {
  .cookie-consent-buttons {
    flex-direction: column;
  }
  
  .cookie-consent-buttons button {
    width: 100%;
  }
  
  .cookie-consent-overlay {
    padding: 16px;
  }
}
</style> 